import { MultiMenuTooltip } from 'components/common'
import React from 'react'
import { lang } from 'utils/helpers'

const Options = ({ isHide, toggleModalDelete, toggleModalEdit }) => {

  const options = [
    [
      {
        label: lang('dashboard_edit_section'),
        onClick: () => toggleModalEdit(),
        closeMenu: true
      },
      {
        label: lang('dashboard_delete_section'),
        onClick: () => toggleModalDelete(),
        closeMenu: true
      }
    ]
  ]
  return (
    <MultiMenuTooltip
      isHide={isHide}
      options={options}
      dotsOrientation={'horizontal'}
      dotsColor={'#999999'}
    />
  )
}

export default Options